import { useMemo, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useRegisterStore } from "@companion-core/shared/app/Store/registerStore";
import { useWizardStore } from "@companion-core/shared/app/Store/wizardStore";
import { useTrackingStore } from "@companion-core/shared/app/Store/trackingStore";
import { getModule } from "@companion-core/shared/app/Utils/config";

export const useRegister = () => {
  const { t } = useTranslation();
  const registerModule = getModule("register");
  const vcesEnabled = useMemo(() => registerModule?.vces?.enabled, [registerModule]);
  const { registerContent, setRegisterContent, resetRegister, isLoading } = useRegisterStore(
    (state) => ({
      registerContent: state.registerContent,
      isLoading: state.isLoading,
      setRegisterContent: state.setRegisterContent,
      setMemberToRegister: state.setMemberToRegister,
      resetRegister: state.resetRegister,
    }),
  );
  const { currentStep, currentForm, formTree, setCurrentStep, setCurrentForm, resetWizard } =
    useWizardStore((state) => ({
      formTree: state.formTree,
      currentForm: state.currentForm,
      currentStep: state.currentStep,
      setCurrentStep: state.setCurrentStep,
      setCurrentForm: state.setCurrentForm,
      resetWizard: state.resetWizard,
    }));
  const { currentPage, setCurrentPage } = useTrackingStore((state) => ({
    currentPage: state.currentPage,
    setCurrentPage: state.setCurrentPage,
  }));

  useEffect(() => {
    setCurrentPage();
  }, []);

  useEffect(() => {
    resetRegister();
    setRegisterContent(vcesEnabled ? "vces" : "register");
  }, [vcesEnabled]);

  return {
    t,
    isLoading,
    vcesEnabled,
    registerContent,
    setRegisterContent,
    currentStep,
    currentForm,
    formTree,
    setCurrentStep,
    setCurrentForm,
    resetWizard,
    currentPage,
  };
};
